module.exports = __webpack_public_path__ + "static/01-fireworks-zoom-ac776ca18a569ec9517c21e4ea775bd4.jpg";